module.exports = __webpack_public_path__ + "static/media/volley-ball.a089b029.png";